import React, { useMemo } from 'react'

import { Field } from 'ui/components/Field'
import { Toggle } from 'ui/components/Toggle'
import { generateUniqueId } from 'ui/helpers/utilities'

import { SectionAttributeEditorProps } from './types'

type SectionCheckboxAttributeEditorProps = SectionAttributeEditorProps<boolean>

export const SectionCheckboxAttributeEditor: React.FC<SectionCheckboxAttributeEditorProps> = ({
    label,
    value,
    onChange,
    isReadOnly,
}) => {
    const id = useMemo(() => generateUniqueId(), [])

    return (
        <Field
            htmlFor={id}
            label={label}
            rightSlotContent={
                <Toggle id={id} checked={value} onCheckedChange={onChange} disabled={isReadOnly} />
            }
        />
    )
}
